import {cyberSourceExpiryDateFormatter, createAndSubmitForm} from "utils";
import {getErrorConfig, getRequestConfig, getCyberSourceConfig} from "utils/requests";
import {history} from "../../store/";
import {
    IS_CART_INITIALISED,
    CART_INITIALISE,
    CART_EMPTIED,
    CART_FETCH,
    CART_FETCH_ERROR,
    PROGRAM_TYPE_FETCH_ERROR,
    SET_ENTITLEMENT,
    CART_REVIEWED,
    CART_COMPLETED,
    PAYMENT_PROCESSED,
    WS_REQUEST,
    URLS,
    SET_TAXES,
    SET_ACTIVE_CART_TAB,
    APP_SHOW_ERROR,
    APP_CLEAR_ERROR,
    CREATE_SIGNATURE_ERROR,
    MODAL_LOCATION,
    TAX_COMPUTATION_ERROR,
    TAX_SERVICE_UNAVAILABLE_ERROR,
    PAYMENT_ERROR,
    CYBERSOURCE_ERROR,
    CART_PROCESSING,
    PAYMENT_CARD,
    PAYMENT_STATUS,
    SET_ADDRESS_VALIDATED,
    SET_ADDRESS_LIST,
    SET_ADDRESS_DETAILS,
    SET_CART_DOCKED,
    UPDATE_ROUTE,
    CYBERSOURCE_VALIDATED,
} from "../constants";
import {productService, checkoutService, canadaPostService} from "../../services/apiService";

export const addressComplete = (term) => async (dispatch, getState) => {
    try {
        const {locale} = getState().app;
        const payload = await canadaPostService.addressComplete(term, locale);
        if (payload.Items[0].Error) {
            dispatch({
                type: SET_ADDRESS_LIST,
                payload: [],
            });
        } else {
            const items = payload.Items.filter((item) => item.Next === "Retrieve");
            dispatch({
                type: SET_ADDRESS_LIST,
                payload: items,
            });
        }
    } catch (error) {
        // If canada post auto complete API fails, we do not show an error as the user can manually enter his address.
        console.log("error", error);
    }
};

export const retrieveAddress = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: SET_ADDRESS_LIST,
            payload: [],
        });
        const {locale} = getState().app;
        const payload = await canadaPostService.retrieveAddress(id);
        const address = {
            addressLine1: locale === "en" ? payload.Items[0].Line1 : payload.Items[1].Line1,
            addressLine3: locale === "en" ? payload.Items[0].City : payload.Items[1].City,
            province: locale === "en" ? payload.Items[0].Province : payload.Items[1].Province,
            postalCode: locale === "en" ? payload.Items[0].PostalCode : payload.Items[1].PostalCode,
        };
        dispatch({
            type: SET_ADDRESS_DETAILS,
            payload: address,
        });
    } catch (error) {
        // If canada post auto complete API fails, we do not show an error as the user can manually enter his address.
        console.log("error", error);
    }
};

export const clearErroronSuccess = () => (dispatch, getState) => {
    const modalIsShown = getState().app.modal.isShown;
    if (modalIsShown) {
        dispatch({
            type: APP_CLEAR_ERROR,
        });
    }
};

export const fetchSkUs = (data) => async (dispatch, getState) => {
    try {
        const {locale} = getState().app;
        const payload = await productService.getSkus(data.skus, locale);
        dispatch({
            type: CART_FETCH,
            payload,
        });
        if (data.program_type_sku) {
            dispatch(fetchProgramType(data.program_type_sku));
        }
        dispatch({
            type: IS_CART_INITIALISED,
            payload: true,
        });
        dispatch(clearErroronSuccess());
    } catch (payload) {
        dispatch({
            type: WS_REQUEST,
            payload: {
                type: CART_FETCH_ERROR,
            },
        });
    }
};

export const fetchProgramType = (sku) => async (dispatch, getState) => {
    try {
        const {
            app: {locale},
            cart: {
                details: {items},
            },
        } = getState();
        const payload = await productService.getProgramType(sku, locale);
        const subtotal = items.reduce((curr, item) => curr + item.price, 0);
        const entitlement = {
            name: payload[0].description,
            price: subtotal,
        };
        dispatch({
            type: SET_ENTITLEMENT,
            payload: entitlement,
        });
        dispatch(clearErroronSuccess());
    } catch (payload) {
        dispatch({
            type: WS_REQUEST,
            payload: {
                type: PROGRAM_TYPE_FETCH_ERROR,
            },
        });
    }
};

export const returnToCart = (data) => (dispatch, getState) => {
    dispatch(sendCartStatus(CART_REVIEWED, false));
    dispatch({
        type: UPDATE_ROUTE,
        value: {main: URLS.CHAT, sub: URLS.DETAILS},
    });
};

export const closeCart = (data) => (dispatch, getState) => {
    window.parent.postMessage({type: "isChatExpanded", value: false}, "*");
    dispatch({
        type: IS_CART_INITIALISED,
        payload: false,
    });
};

export const setCartDocked = (value) => ({
    type: SET_CART_DOCKED,
    payload: value,
});

export const updateCartStatus = (data) => (dispatch, getState) => {
    switch (data.type) {
        case CART_INITIALISE:
            if (!data.value) {
                break;
            }
            window.parent.postMessage({type: "isChatExpanded", value: data.value}, "*");
            dispatch({type: SET_CART_DOCKED, payload: false});
            dispatch({type: CART_INITIALISE, payload: data.value});
            dispatch(fetchSkUs(data.value));
            dispatch({
                type: UPDATE_ROUTE,
                value: {main: URLS.CHAT, sub: URLS.DETAILS},
            });
            break;
        case CART_EMPTIED:
            dispatch({
                type: CART_EMPTIED,
                payload: data.value,
            });
            dispatch(closeCart());
            break;
        case CART_REVIEWED:
            dispatch({
                type: CART_REVIEWED,
                payload: data.value,
            });
            break;
        case CART_COMPLETED:
            dispatch({
                type: CART_COMPLETED,
                payload: data.value,
            });
            break;
        case PAYMENT_PROCESSED:
            dispatch({type: CYBERSOURCE_VALIDATED, payload: true});
            dispatch(validateCartCompletion(data.value));
            break;
        default:
            break;
    }
};

export const sendCartStatus =
    (type, status, data = {}) =>
    (dispatch, getState) => {
        dispatch({
            type: WS_REQUEST,
            payload: {
                type,
                value: {status, ...data},
            },
        });
    };

export const validateCartCompletion = (data) => (dispatch, getState) => {
    const {
        cart: {
            address: {
                shipping: {email, firstName, lastName},
            },
        },
    } = getState();
    if (data.valid) {
        dispatch(
            sendCartStatus(CART_COMPLETED, true, {
                name: `${firstName} ${lastName}`,
                email,
                id: data.referenceNumber,
                providerId: data.providerTransactionId,
            }),
        );
        dispatch({
            type: UPDATE_ROUTE,
            value: {main: URLS.CHAT, sub: URLS.COMPLETE},
        });
        if (!data.validFromProvider && data.reasonCode === "104") {
            dispatch(handleError({code: CYBERSOURCE_ERROR}));
        } else {
            dispatch(clearErroronSuccess());
        }
    } else if (data.orderStatus === PAYMENT_STATUS.DECLINED) {
        dispatch(handleError({code: PAYMENT_ERROR}));
    } else {
        dispatch(handleError({code: CREATE_SIGNATURE_ERROR}));
    }
};

export const revertCartPaymentProcessing = () => (dispatch, getState) => {
    dispatch({
        type: CART_PROCESSING,
        payload: false,
    });
    dispatch(clearErroronSuccess());
};

export const reviewOrder = () => async (dispatch, getState) => {
    try {
        const {
            cart: {
                details: {cartId, subTotal},
                address: {
                    shipping: {
                        addressLine1,
                        addressLine2,
                        addressLine3,
                        email,
                        firstName,
                        lastName,
                        postalCode,
                        province,
                    },
                },
            },
            app: {webSocketId, locale},
        } = getState();
        const payload = {
            address: addressLine1,
            address2: addressLine2,
            orderId: webSocketId,
            cartId,
            city: addressLine3,
            email,
            firstname: firstName,
            lastname: lastName,
            postalcode: postalCode,
            state: province,
            caseOrigin: "chat",
        };
        dispatch({
            type: CART_PROCESSING,
            payload: true,
        });
        const response = await checkoutService.createSignature(payload, locale);
        if (subTotal) {
            dispatch(processPayment(response));
        } else {
            dispatch(sendCartStatus(CART_REVIEWED, true));
            dispatch(validateCartCompletion({valid: true, ...response}));
        }
    } catch (err) {
        if (err.response.data.status === "CONFLICT") {
            dispatch(handleError({code: PAYMENT_ERROR}));
        } else {
            dispatch(handleError({code: CREATE_SIGNATURE_ERROR, ...err}));
        }
    }
};

export const computeTaxes = () => async (dispatch, getState) => {
    try {
        const {
            details: {cartId},
            address: {
                shipping: {addressLine1, addressLine3, email, firstName, lastName, postalCode, province},
            },
        } = getState().cart;
        const payload = {
            cartId,
            city: addressLine3,
            postalcode: postalCode,
            state: province,
            address: addressLine1,
        };
        const data = await checkoutService.calculateTaxes(payload);
        let GST = 0;
        let PST = 0;
        let HST = 0;
        data.taxDetails.forEach((value) => {
            value.details.forEach((taxes) => {
                if (taxes.type.indexOf("GST") >= 0) {
                    GST += taxes.amount;
                } else if (taxes.type.indexOf("PST") >= 0 || taxes.type.indexOf("QST") >= 0) {
                    PST += taxes.amount;
                } else if (taxes.type.indexOf("HST") >= 0) {
                    HST += taxes.amount;
                }
            });
        });
        dispatch({
            type: SET_TAXES,
            payload: {
                taxes: {
                    gst: parseFloat(GST),
                    pst: parseFloat(PST),
                    hst: parseFloat(HST),
                    details: data.taxDetails,
                },
                subTotal: parseFloat(data.subtotal),
            },
        });
        dispatch({
            type: UPDATE_ROUTE,
            value: {main: URLS.CHAT, sub: URLS.PAYMENT},
        });
    } catch (err) {
        console.log("res", err.response);
        if (err.response.data.status === "BAD_REQUEST") {
            dispatch(handleError({code: TAX_COMPUTATION_ERROR, ...err}));
        } else {
            dispatch(handleError({code: TAX_SERVICE_UNAVAILABLE_ERROR, ...err}));
        }
        dispatch(setAddressValidated(false));
    }
};

export const setActiveCartTab = (payload) => ({
    type: SET_ACTIVE_CART_TAB,
    payload,
});

export const proceedToPayment = () => (dispatch, getState) => {
    const {
        cart: {
            details: {subTotal},
        },
    } = getState();
    if (subTotal) {
        dispatch(sendCartStatus(CART_REVIEWED, true));
        dispatch({
            type: UPDATE_ROUTE,
            value: {main: URLS.CHAT, sub: URLS.ADDRESS},
        });
    } else {
        dispatch(reviewOrder());
    }
};

export const handleError = (err) => (dispatch) => {
    const error = getErrorConfig(err.code);
    dispatch({
        type: APP_SHOW_ERROR,
        payload: {...error, location: MODAL_LOCATION.CART, code: err.code},
    });
};

export const setAddressValidated = (value) => (dispatch) => {
    dispatch({
        type: SET_ADDRESS_VALIDATED,
        payload: value,
    });
};

export const processPayment = (data) => async (dispatch, getState) => {
    let cybReqFlag = false;
    const {
        cart: {
            address: {
                shipping: {addressLine1, addressLine2, addressLine3, email, firstName, lastName, postalCode, province},
            },
            details: {items, taxes},
            payment: {
                details: {cardType, cardNumber, expiryDate},
            },
        },
        app: {webSocketId, locale},
    } = getState();
    dispatch({
        type: CYBERSOURCE_VALIDATED,
        payload: false,
    });
    const cards = {
        [PAYMENT_CARD.visa.label]: "001",
        [PAYMENT_CARD.mastercard.label]: "002",
        [PAYMENT_CARD.amex.label]: "003",
    };
    const products = {};
    taxes.details.forEach((detail, i) => {
        const product = items.find((item) => item.sku.toString() === detail.sku);
        products[`item_${i}_tax_amount`] = detail.total;
        products[`item_${i}_sku`] = detail.sku;
        products[`item_${i}_unit_price`] = product.price;
    });
    const payload = {
        unsigned_field_names: data.unsignedFieldNames,
        amount: data.total,
        tax_amount: data.tax,
        bill_to_address_postal_code: postalCode,
        bill_to_address_state: province,
        transaction_uuid: data.transactionUuId,
        signed_field_names: data.signedFieldNames,
        locale,
        transaction_type: "sale",
        bill_to_email: email,
        reference_number: data.referenceNumber,
        bill_to_address_country: "CA",
        bill_to_surname: lastName,
        bill_to_address_line1: addressLine1,
        bill_to_address_line2: addressLine2,
        bill_to_address_city: addressLine3,
        currency: "CAD",
        bill_to_forename: firstName,
        signed_date_time: data.signedDateTime,
        payment_method: "card",
        signature: data.signature,
        card_type: cards[cardType],
        card_number: cardNumber,
        card_expiry_date: cyberSourceExpiryDateFormatter(expiryDate),
        profile_id: data.profileId,
        access_key: data.accessKey,
        merchant_defined_data1: webSocketId,
        line_item_count: items.length,
        ...products,
    };
    const iframe = document.createElement("iframe");
    iframe.setAttribute("id", "covert_payment");
    iframe.name = "covert";
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    let counter = 2;
    iframe.addEventListener(
        "load",
        (evt) => {
            counter -= 1;
            if (timer && !counter) {
                cybReqFlag = false;
            }
        },
        false,
    );
    cybReqFlag = true;
    createAndSubmitForm(payload, getCyberSourceConfig(), iframe);
    const timer = setTimeout(() => {
        const {
            cart: {
                details: {isCyberSourceValidated},
            },
        } = getState();
        console.log("isCyberSourceValidated", isCyberSourceValidated);
        console.log("cybReqFlag", cybReqFlag);
        if (cybReqFlag || !isCyberSourceValidated) {
            dispatch(handleError({code: CREATE_SIGNATURE_ERROR}));
        }
    }, 20000);
};



// WEBPACK FOOTER //
// ./src/containers/Cart/actions.js